import { render, staticRenderFns } from "./h5.option.vue?vue&type=template&id=25a6127f"
import script from "./h5.option.vue?vue&type=script&lang=js"
export * from "./h5.option.vue?vue&type=script&lang=js"
import style0 from "./h5.option.vue?vue&type=style&index=0&id=25a6127f&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports